import clsx from "clsx";
import { format, parse } from "date-fns";
const BookingStartDate: React.FC<{ startDate: string; className?: string }> = ({ startDate, className }) => {
  const parsedDate = parse(startDate, "yyyy-MM-dd", new Date());
  return (
    <span className={clsx(className)}>
      {startDate && !Number.isNaN(parsedDate?.getTime()) ? format(parsedDate, "dd MMM yyyy") : startDate}
    </span>
  );
};

export default BookingStartDate;
